import styled from 'styled-components'
import React, { useContext, useState } from 'react'
import Select from 'react-select'
import { Input } from '@futures-platform/ui'
import { ACTIONS } from '../../store/Actions'
import { DataContext } from '../../store/GlobalState'
import styles from '../../styles.module.css'

const DevelopmentPathItem = ({ dp, id, options, deleteClick }) => {
  const {
    dispatch,
    state: { devPaths },
  } = useContext(DataContext)

  // const [year, setYear] = useState(dp.year)
  // const [description, setDescription] = useState(dp.description)

  const stripAllHtml = (html) => {
    if (!html) return '';
    let tmp = document.createElement("div");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  }

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData('text/plain');
    const modifiedText = stripAllHtml(pastedText);
    document.execCommand('insertText', false, modifiedText);
  };

  return (
    <div
      className="d-flex w-100"
      style={{
        position: 'relative',
      }}>
      <Select
        name="yearYear"
        className={`${styles['custom-react-select-height-att']}`}
        value={{ label: dp?.year }}
        style={{ width: '80px' }}
        options={options}
        searchable={true}
        clearable={false}
        onChange={(v) => {
          const value = v.value
          // setYear(() => value)
          const temp = [...devPaths]
          temp[id] = {
            description: temp[id]?.description,
            year: value,
            isSubmited: false,
          }
          dispatch({
            type: ACTIONS.DEVPATHS,
            payload: temp,
          })
          // dp.year = v.value
        }}
      />
      <textarea
        type="text"
        name="yearDescription"
        value={dp.description}
        onChange={(v) => {
          const value = v.target.value
          // setDescription(() => value)
          // dp.description = v.target.value
          const temp = [...devPaths]
          temp[id] = {
            description: value,
            year: temp[id]?.year,
            isSubmited: false,
          }
          dispatch({
            type: ACTIONS.DEVPATHS,
            payload: temp,
          })
        }}
        style={{
          marginLeft: '20px',
          minHeight: '100px',
          maxWidth: '80%',
          position: 'relative',
        }}
        onPaste={handlePaste}
        onBlur={(e) => {
          const temp = [...devPaths]
          temp[id] = stripAllHtml(temp[id])
          dispatch({
            type: ACTIONS.DEVPATHS,
            payload: temp,
          })
        }}
      />
      <Close
        className="btn-round btn-sm af-custom-close"
        onClick={deleteClick}
      />
    </div>
  )
}

export const DevelopmentPath = (props) => {
  let { value } = props
  const {
    dispatch,
    state: { devPaths },
  } = useContext(DataContext)

  // const [devPathRows, setdevPathRows] = React.useState(value || [])

  const endYear = 2200
  const startYear = 2023

  const years = React.useMemo(() => {
    return [...Array(endYear - startYear + 1).keys()].map((i) => i + startYear)
  }, [endYear, startYear])
  const options = React.useMemo(() => {
    return years.map((year) => {
      return { value: year, label: year }
    })
  }, [years])

  const addMore = (e) => {
    e.preventDefault()
    e.stopPropagation()
    // setdevPathRows(() => [
    //   ...devPathRows,
    //   {
    //     year: 2023,
    //     description: '',
    //     isSubmited: false,
    //   },
    // ])
    dispatch({
      type: ACTIONS.DEVPATHS,
      payload: [
        ...devPaths,
        {
          year: 2023,
          description: '',
          isSubmited: false,
        },
      ],
    })
  }

  const deleteClick = React.useCallback(
    (i) => {
      // setdevPathRows(() => {
      //   const devPathsTemp = [...devPathRows]
      //   devPathsTemp.splice(i, 1)
      //   return devPathsTemp
      // })
      const devPathsTemp = [...devPaths]
      devPathsTemp?.splice(i, 1)
      dispatch({
        type: ACTIONS.DEVPATHS,
        payload: devPathsTemp,
      })
      // onChange(newValues)
    },
    [devPaths, dispatch],
  )

  return (
    <>
      {!!devPaths?.length &&
        devPaths.map((dp, i) => (
          <DevelopmentPathItem
            dp={dp}
            key={i}
            id={i}
            options={options}
            deleteClick={() => deleteClick(i)}
          />
        ))}

      {/* devPathRows.map((dp, i) => DevelopmentPathItem(dp, i, options))} */}
      <AddDevPathBtn
        className="btn btn-outline-secondary"
        // disabled={disabled}
        onClick={addMore}
        type="button"
        style={{
          width: 'fit-content',
          height: 'fit-content',
          marginLeft: '100px',
        }}>
        <Plus className="af-custom-plus" /> Add
      </AddDevPathBtn>
    </>
  )
}

const AddDevPathBtn = styled.button`
  width: 'fit-content';
  height: 'fit-content';
  color: #006998;
  border-color: #006998
  &:hover {
    color: #fff !important;
    background-color: #006998 !important;
    border-color: #006998 !important;
  }
`
const Plus = styled.span`
  // position: absolute;
  right: 0;
  top: 0;
  cursor: pointer;
`
const Close = styled.span`
  position: absolute;
  right: 0;
  top: 40%;
  cursor: pointer;
`
